import BasicInput, { BasicInputProps } from './BasicInput';

export default BasicInput;
export type { BasicInputProps };
